// SupportHubPage — Help center, FAQ, messages, feedback, legal

import { HubLayout } from './HubLayout';

export function SupportHubPage() {
  return (
    <HubLayout
      title="Support"
      testIdRoot="hub-support"
      hero={{
        title: "We're here 24/7",
        subtitle: 'Help, FAQ, live chat, legal',
        emoji: '💬',
        gradient: 'linear-gradient(135deg, #5856D6 0%, #FF2D55 100%)',
        stats: [
          { label: 'Avg reply',  value: '<2 min', sub: 'live chat', color: '#34C759' },
          { label: 'Uptime',     value: '99.97%', sub: 'last 30d' },
          { label: 'Languages',  value: '8',      sub: 'supported' },
        ],
      }}
      quickActions={[
        { to: '/portal/messages',   label: 'Live chat',  icon: '💬', testId: 'hub-support-qa-chat' },
        { to: '/portal/faq-center', label: 'FAQ',        icon: '❓', testId: 'hub-support-qa-faq' },
        { to: '/portal/help-center',label: 'Guides',     icon: '📚', testId: 'hub-support-qa-guides' },
      ]}
      sections={[
        {
          title: 'Get Help',
          items: [
            { to: '/portal/messages',    icon: '💬', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Live chat',         sub: 'Reply in <2 min · 24/7',     badge: { text: 'Online', color: 'white', bg: '#34C759' } },
            { to: '/portal/messages/msg-001', icon: '🔎', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Message thread',  sub: 'Single conversation' },
            { to: '/portal/faq-center',  icon: '❓', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'FAQ center',         sub: '30+ articles · 6 categories' },
            { to: '/portal/help-center', icon: '📚', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Help articles',      sub: 'Guides & walkthroughs' },
            { to: '/portal/article/getting-started', icon: '🚀', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Getting started', sub: '5-min walkthrough' },
            { to: '/portal/help',        icon: '💡', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Help home',         sub: 'All help resources' },
          ],
        },
        {
          title: 'Feedback & Legal',
          items: [
            { to: '/portal/feedback',     icon: '💌', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Send feedback',     sub: 'Help us improve' },
            { to: '/portal/disclosures',  icon: '📋', iconBg: 'linear-gradient(135deg, #1C1C1E 0%, #48484A 100%)', label: 'Legal disclosures', sub: 'Terms · Privacy · Risk · Cookies' },
            { to: '/portal/search',       icon: '🔍', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'Search help',       sub: 'Search articles' },
          ],
        },
      ]}
    />
  );
}
